"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitTransaction = exports.subscribeModel = exports.fetchModel = void 0;
var Pod_1 = require("../../../net/Pod");
var fetchModel = function () { return (0, Pod_1.PodRequest)('fetch_model', 'reply_model'); };
exports.fetchModel = fetchModel;
var subscribeModel = function () { return (0, Pod_1.PodRequest)('subscribe_model', 'acknowledge'); };
exports.subscribeModel = subscribeModel;
var submitTransaction = function (txData) { return (0, Pod_1.PodRequest)('submit_tx', 'reply_tx', txData); };
exports.submitTransaction = submitTransaction;
